import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "In sickness and in death",
  "description": "",
  "published": "2007-12-19T00:00:00.000Z",
  "redirect_from": ["/blog/in-sickness-and-in-death/swizec/141"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the past week I have been pestered by a terrible illness that put me in bed for many days. I suffered horrible pains and fevers and what I still claim to be fever-induced hallucinations rather than half crazed dreams and visions. It looked so real!`}</p>
    <p>{`At first the good doctor scared me quite a bit when I was told I had some form of viral tonsil infection that is in fact a saliva transfered STD. The problem there being that since it's viral it cannot be cured; you simply have to wait it out. Of course suffering an illness out brings along a great deal of trouble, namely pain and apparently, in this case, even up to 50% increase in size of some internal organs like the liver and spleen ... with danger of ruptures. Also I'd be bedridden for a whole fortnight.`}</p>
    <p>{`Luckily for me and my freshly new sex life (no strenuous activity until February in the previously describe eventuality) antibiotics worked and the infection turned out to be a more managable thing that was cured in a few days and I shall be regaining normality tomorrow. Of course I still have to take the pills for as long as they last and I can't start going to the gym until next week ... and even then slowly ease in ... as if I will. I'm glad I can get back to work and classes because having stayed at home for this long a time I can tell you, it's not lovely at all.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      